export class PubSubTopic {
  constructor() {
    this.listeners = [];
  }

  addListener(fn) {
    this.listeners.push(fn);
  }

  publishTopic() {
    for (let i = 0; i < this.listeners.length; i++) {
      this.listeners[i].apply(this, arguments);
    }
  }
};

export class PubSub {
  constructor() {
    // all topics
    this.topics = {};
    // topicId
    this.topicId = -1;
  }

  subscribe(topic, func) {
    if (typeof func !== 'function' || typeof topic !== 'string') {
      return false;
    }
    if (!this.topics.hasOwnProperty(topic)) {
      this.topics[topic] = new PubSubTopic(topic);
    }
    this.topics[topic].addListener(func);
  }

  publish(topic, data) {
    if (!this.topics.hasOwnProperty(topic)) {
      return false;
    }
    try {
      const topicObj = this.topics[topic];
      topicObj.publishTopic(data);
    } catch (e) {
      console.error('publish event error: ', e);
      return true;
    }
    return true;
  }

  findTopic(topic) {
    if (this.topics.hasOwnProperty(topic)) {
      return true;
    }
    return false;
  }
}

export var EventPubSub = new PubSub();
